import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Tenant } from '../types'

interface TenantState {
  tenant: Tenant | null
  token: string | null
  isAuthenticated: boolean
  setTenant: (tenant: Tenant) => void
  setToken: (token: string) => void
  logout: () => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      tenant: null,
      token: null,
      isAuthenticated: false,
      setTenant: (tenant) => set({ tenant, isAuthenticated: true }),
      setToken: (token) => {
        set({ token })
        localStorage.setItem('uzm_token', token)
      },
      logout: () => {
        set({ tenant: null, token: null, isAuthenticated: false })
        localStorage.removeItem('uzm_token')
      },
    }),
    {
      name: 'uzm-tenant-storage',
    },
  ),
)
